module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/py-b19bb0ae9ad5d553a146f088ed6fa4a0.svg";